export default __webpack_public_path__ + "static/media/42.d9082710.jpeg";